export default "__VITE_ASSET__faa6e04b__"